export enum EditCompanyTab {
  INFOS = 'infos',
  LINKED_BRANCHES = 'linkedBranches',
  WHITE_LABEL = 'whiteLabel',
}
